const baseUrl = '/fees';
export const feesRoutes = {
  baseUrl: "".concat(baseUrl)
};